import { createCurrencyFormatter } from './currency';
import { language, propertyLanguage } from './language';

function findLastNumbericValueIndex(value) {
  if (typeof value !== 'string') {
    return -1;
  }

  for (let i = value.length - 1; i >= 0; i--) {
    if (/\d/.test(value[i])) {
      return i;
    }
  }

  return -1;
}

export const makeAmountInput = (inputElement, currency) => {
  const $input = $(inputElement);

  const amountFormatter = createCurrencyFormatter({
    language: propertyLanguage ?? language,
    currency,
  });

  $input.on('input', ($event) => {
    const { value } = $event.target;
    const letters = value.split();
    const last = letters.pop();
    const lastValidated = last.replace(/\D/g, '');
    const valueValidated = [...letters, lastValidated].join('');
    const valueFormatted =
      valueValidated.length > 0 ? amountFormatter(valueValidated) : '';
    $input.val(valueFormatted);

    const lastDigitIndex = findLastNumbericValueIndex(valueFormatted) + 1;
    if (lastDigitIndex > 0) {
      inputElement.setSelectionRange(lastDigitIndex, lastDigitIndex);
    }

    // trigger custom input change event - to trigger validation
    const inputChange = new CustomEvent('inputChange', {
      detail: {
        value: valueFormatted,
      },
    });
    $input.get()[0].dispatchEvent(inputChange);
  });
};

export const amountToInteger = (amountString) => {
  return parseInt(amountString?.replace(/\D/g, ''));
};
